import * as React from 'react';
function InfoRow({text}) {
    return ( <p className='border-b border-gray p-2 text-gray text-lg'>{text}</p> );
}

export default InfoRow;